var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LeaveWasApproved',{attrs:{"event":_vm.event,"summary":_vm.summary}})
}
var staticRenderFns = []

export { render, staticRenderFns }